module.exports = __webpack_public_path__ + "img/tuijianchapin.b0c42be3.png";